/**
 * Stable CSS class names for E2E — Payment Consolidation page.
 */
export const PC = {
    page: 'payment-consolidation-page',
    breadcrumbSection: 'payment-consolidation-page__breadcrumb-section',
    loadingSection: 'payment-consolidation-page__loading-section',
    mainLayout: 'payment-consolidation-page__main-layout',

    inputColumn: 'payment-consolidation-page__input-column',
    searchCard: 'payment-consolidation-page__search-card',
    searchCardContent: 'payment-consolidation-page__search-card-content',
    inputTextShippingNumbers: 'payment-consolidation-page-input--text-shipping-numbers',

    actionsRow: 'payment-consolidation-page__actions-row',
    clearButtonWrap: 'payment-consolidation-page__clear-button-wrap',
    inputButtonClear: 'payment-consolidation-page-input--button-clear',
    searchButtonWrap: 'payment-consolidation-page__search-button-wrap',
    inputButtonSearch: 'payment-consolidation-page-input--button-search',

    resultsColumn: 'payment-consolidation-page__results-column',
    resultsCard: 'payment-consolidation-page__results-card',
    resultsCardContent: 'payment-consolidation-page__results-card-content',
    resultsTitle: 'payment-consolidation-page__results-title',
    copyResultsButton: 'payment-consolidation-page-input--button-copy-results',
    resultsListWrap: 'payment-consolidation-page__results-list-wrap',
    resultsList: 'payment-consolidation-page__results-list',
    resultsListItem: 'payment-consolidation-page__results-list-item',

    summaryColumn: 'payment-consolidation-page__summary-column',
    summaryCard: 'payment-consolidation-page__summary-card',
    summaryCardContent: 'payment-consolidation-page__summary-card-content',
    summaryTitle: 'payment-consolidation-page__summary-title',
    summaryGrid: 'payment-consolidation-page__summary-grid',
    summaryStatItem: 'payment-consolidation-page__summary-stat-item',

    dataGridSection: 'payment-consolidation-page__data-grid-section',
} as const;

export const pcCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
